import type { Tokens } from "../types/domain";

const STORAGE_KEY = "solleciti_session";
const STORAGE_PREFIX = "solleciti_";
const REMEMBERED_KEY = "solleciti_remembered";

export const SESSION_EXPIRED_EVENT = "solleciti:session-expired";

const KEEP_ON_CLEAR = new Set([REMEMBERED_KEY]);

function clearNamespacedStorage(storage: Storage): void {
  const keysToRemove: string[] = [];

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (key?.startsWith(STORAGE_PREFIX) && !KEEP_ON_CLEAR.has(key)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => storage.removeItem(key));
}

export function getStoredTokens(): Tokens | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as Tokens;
  } catch {
    return null;
  }
}

export function setStoredTokens(tokens: Tokens): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function clearStoredTokens(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export interface RememberedCredentials {
  email: string;
  password: string;
}

export function getRememberedCredentials(): RememberedCredentials | null {
  const raw = localStorage.getItem(REMEMBERED_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as RememberedCredentials;
  } catch {
    return null;
  }
}

export function setRememberedCredentials(creds: RememberedCredentials): void {
  localStorage.setItem(REMEMBERED_KEY, JSON.stringify(creds));
}

export function clearRememberedCredentials(): void {
  localStorage.removeItem(REMEMBERED_KEY);
}

export function clearAppStorage(): void {
  clearNamespacedStorage(localStorage);
  clearNamespacedStorage(sessionStorage);
}

export function notifySessionExpired(): void {
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
}
